import { setFrontNews } from "../../scripts/news.js";
import { calenderFrontpage } from "../../scripts/calendar";
import { setCampaign } from "../../scripts/campaigns";
import language from "../../scripts/translation";

export default function(client, clientid) {

    // console.log("test");


    setFrontNews();
    calenderFrontpage(client, 4);
    let camp = setCampaign();

    return `<div class="container">
                <div class="col" id="warnings_container"></div>
                <div class="row">
                    <div class="col-md-6">
                        <h2 class="frontpage__header">${language("START_NEWSHEADER")}</h2>
                        <div class="row">
                            <div class="col-12 col-md-10" id="news">
                            
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h2 class="frontpage__header">${language("START_CALENDAR")}</h2>
                        <div id="events">
                        
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                                                
                        </div>
                    </div>
                </div>
                
                
                <div class="campaign">
                    <div class="row justify-content-md-center" id="campaigns">${camp}</div>
                    
                </div>
            </div>`;


}
